import { SentimentDataByPeriod } from '../../../types/sentiment.type';
import { getSentimentLevel } from '../../../utils/utils';
import { PERIOD_OPTIONS } from '../SentimentWidget';

interface SentimentTableProps {
  data: SentimentDataByPeriod;
  latestScoreDate?: string;
}

const SentimentTable = ({ data, latestScoreDate }: SentimentTableProps) => {
  if (!data) return null;
  return (
    <div className="sentiment-table">
      <div className="sentiment-table-header">
        <span style={{ minWidth: 24 }}></span>
        <span className="sentiment-table-title">Avg Sentiment</span>
        {latestScoreDate && (
          <span className="sentiment-table-latest">
            Latest Score: {latestScoreDate}
          </span>
        )}
        <span style={{ minWidth: 24 }}></span>
      </div>
      <div className="sentiment-table-rows">
        {PERIOD_OPTIONS.map((opt) => {
          const rawSentiment = data[opt.value]?.overall.sentiment;
          const score =
            rawSentiment === null || rawSentiment === undefined
              ? '-'
              : Number(rawSentiment).toFixed(2);

          const { label, tone } = getSentimentLevel(rawSentiment);
          return (
            <div key={opt.value} className="sentiment-table-row">
              <span style={{ minWidth: 24 }}></span>
              <span className="sentiment-table-period">{opt.label}</span>
              <span className="sentiment-table-label">{label}</span>
              <span className={`sentiment-table-score ${tone}`}>{score}</span>
              <span style={{ minWidth: 24 }}></span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SentimentTable;
